import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute,
} from "amazon-cognito-identity-js";

const UserPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
const ClientId = process.env.REACT_APP_COGNITO_CLIENT_ID;

if (!UserPoolId || !ClientId) {
  throw new Error("Missing Cognito environment variables");
}

const poolData = {
  UserPoolId,
  ClientId,
};

const userPool = new CognitoUserPool(poolData);

export function signUp(email, password) {
  return new Promise((resolve, reject) => {
    const attributeList = [
      new CognitoUserAttribute({
        Name: "email",
        Value: email,
      }),
    ];

    userPool.signUp(email, password, attributeList, null, (err, result) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(result);
    });
  });
}

export function confirmSignUp(email, code) {
  return new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: userPool,
    });

    cognitoUser.confirmRegistration(code, true, (err, result) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(result);
    });
  });
}

export function signIn(email, password) {
  return new Promise((resolve, reject) => {
    const authenticationDetails = new AuthenticationDetails({
      Username: email,
      Password: password,
    });

    const userData = {
      Username: email,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        const token = result.getIdToken().getJwtToken();
        localStorage.setItem("token", token);
        localStorage.setItem("email", email);
        resolve(result);
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
}

export function signOut() {
  const currentUser = userPool.getCurrentUser();
  if (currentUser) {
    currentUser.signOut();
  }
  localStorage.removeItem("token");
  localStorage.removeItem("email");
}

export function getToken() {
  return localStorage.getItem("token");
}

export function getCurrentEmail() {
  return localStorage.getItem("email");
}

export function isAuthenticated() {
  return !!localStorage.getItem("token");
}